import React from 'react';
import PropTypes from 'prop-types';

const ProgramRulesPage = ({
  signatureData,
  staffSignatureData,
  currentDate,
}) => {

  // Program rules list
  const rules = [
    "No use of alcohol or any type of mood or mind-altering substances at any time.",
    "The use of alcohol or drugs may be grounds for immediate discharge from the program.",
    "Confidentiality regarding the presence and disclosure of all clients is to be strictly followed.",
    "No violence or threats of violence will be tolerated. Possession of weapons, acts of violence, or threats of violence may be grounds for immediate discharge.",
    "Loud and vulgar talking is prohibited. Appropriate and responsible conduct is always expected.",
    "Cell phones, laptops, cameras, & I-Pads are prohibited - unless otherwise specified on a case-by-case basis.",
    "Smoking or the use of smokeless tobacco products are allowed in designated outside areas only.",
    "Clients may not lend or borrow personal items.",
    "Theft from other clients, retail stores, etc. will not be tolerated.",
    "The primary therapist must approve all visits and passes in advance.",
    "Clients will be responsible for taking medication at the appropriate times.",
    "Sunglasses may not be worn inside.",
    "No 'energy drinks' or weight training supplements are permitted.",
    "Clients must attend all treatment activities unless excused by staff.",
    "Possession and use of vehicles is by staff permission only. Staff reserves the right to search vehicles at any time with or without client presence.",
    "Negative contracts involving major rule violations not reported to staff will result in consequences or discharge.",
    "Clients will respect the personal property of other Clients and staff. Clients will not borrow the property of others.",
    "Clients are responsible for their behavior and are expected to communicate, cooperate, and show respect to other Clients and staff.",
    "All visitors must be approved by staff.",
    "Failure to abide by the rules may result in restriction of privileges. In more serious cases, repeated violations or disregard for program rules will result in administrative discharge.",
    "Sexual relationships with peers are grounds for dismissal as they are considered detrimental to the community and to the individual's recovery process.",
    "Being on time to all scheduled activities is required.",
    "All treatment assignments are to be completed in a timely manner.",
    "All assigned work responsibilities must be completed.",
    "When you do not know what to do, do not assume. Ask the staff, your buddy, or your therapist.",
    "No profanity or verbal abuse of staff or other peers is allowed.",
    "Logos on clothing that are gang or drug related are not permitted.",
    "Clients will dress in casual appropriate clothing. Shirts and shoes must be always worn.",
    "No tank tops, ripped t-shirts, T-Shirts advertising drugs/alcohol, halter-tops, backless or low-cut clothing, short shorts, or other tight clothing are permitted. Appropriate dress/skirt length should reach bottom of knees.",
    "Undergarments must be always worn.",
    "No medications of any kind are allowed unless approved and prescribed by your physician.",
    "No stealing, borrowing, or lending of money is permitted.",
    "Knowledge and awareness of all rules is expected.",
    "At no point are clients to exchange monies, items or favors for services from or for another client or staff member for any reason.",
    "All clients are to provide an emergency contact upon admission to Legacy Healing Center.",
    "Any time a client, living on our property, purchases a vehicle the client must provide copies of a valid driver's license, registration and insurance prior to the vehicle going over to the residence.",
    "All medication prescribed by an outside physician must be brought to Legacy and reviewed by medical staff.",
    "Any client residing at Celebration Point is consenting for them to have a photo of their face, their first name and first letter of their last name as well as their unit number provided to Celebration Point's leasing office."
  ];

  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "2460px",
        fontSize: "18px"
      }}
    >
      {/* Title */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h2 style={{
          fontFamily: 'Arial',
          fontSize: '14pt',
          fontWeight: 'bold',
          // paddingBottom: '5px',
          borderBottom: '2px solid black',
          display: 'inline-block'
        }}>
  Program Rules
        </h2>
      </div>
      

      {/* Introduction */}
      <div style={{ marginBottom: '40px' }}>
        <p>
          The following rules and guidelines have been developed to assist our clients while in residential treatment. We understand it is important in recovery to maintain personal responsibility, and to be informed of what is expected. By establishing clear guidelines, we hope to assist our clients in behavioral and attitude changes that facilitate long-term recovery.
        </p>
      </div>

      {/* Rules List */}
      <div style={{ marginBottom: '20px' }}>
        <ol style={{
          paddingLeft: '20px',
          listStyleType: 'none',
          counterReset: 'rule-counter'
        }}>
          {rules.map((rule, index) => (
            <li key={index} style={{
              marginBottom: '10px',
              counterIncrement: 'rule-counter',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: '-20px',
                fontWeight: 'bold'
              }}>
                {index + 1}.
              </span>
              <span style={{ marginLeft: '10px' }}>{rule}</span>
            </li>
          ))}
        </ol>
      </div>

      {/* Footer */}
      <div style={{ marginBottom: '30px' }}>
        <p style={{ marginBottom: '15px' }}>
          Behavior that undermines treatment rules and expectations will not be tolerated. Violation of these rules will result in consequences and may result in dismissal from the program. Illegal activity is subject to criminal prosecution.
        </p>
        <p style={{ marginBottom: '15px' }}>
          <span style={{fontWeight:'bold'}}>Legacy Healing Center </span>Program Rules have been explained to me so that I understand them. I have received a copy of these rules.
        </p>
      </div>

      <div
        style={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>
    </div>
  );
};

ProgramRulesPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default ProgramRulesPage;